module.exports = __webpack_public_path__ + "img/img2.86b6c327.jpg";